import React from 'react'
import useLocationMutation from './use-location-mutation'
import { Form, Button, ButtonGroup } from 'react-bootstrap'
import { Check, X, CloudUpload } from 'react-bootstrap-icons'

const EditLocationForm = ({
    id,
    name: existingName,
    onClose = () => {}
}) => {
    const {
        name,
        setName,
        saveLocation,
        isSaving,
    } = useLocationMutation({ id, name: existingName, onSuccess: onClose })
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
        >
            <div style={{ display: 'flex', flex: 1, paddingRight: '20px' }}>
                <Form.Control type="text" placeholder="Enter Location Name" value={name || ''} onChange={e => setName(e.target.value)} disabled={isSaving}/>
            </div>
            <div>
                <ButtonGroup>
                    <Button size="sm" variant="light" onClick={() => onClose()}><X /></Button>
                    <Button size="sm" variant="success" onClick={() => saveLocation()} disabled={isSaving}><CloudUpload /></Button>
                </ButtonGroup>
            </div>
        </div>
    )
}

export default EditLocationForm